const NAME = '5FORTY'

// exports
export const CANONICAL_URL_ROOT   = 'https://www.5forty.com'
export const COPYRIGHT_STATEMENT  = `© ${(new Date()).getFullYear()} ${NAME}`
export const HOME_PAGE_TITLE      = 'Watch Skate Videos'
export const LEGAL_NAME           = `${NAME}, LLC`
export const PAGE_TITLE_SEPARATOR = '—'
export const SITE_DESCRIPTION     = 'Watch full-length skate videos and parts. With classic and current skate videos added regularly, 5FORTY is built by skateboarding.'
export const SITE_NAME            = `${NAME}`
export const VIEWPORT_SETTING     = 'width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no,shrink-to-fit=no'



// WEBPACK FOOTER //
// ./src/common/constants/meta-tags.js